import React from 'react';
import { IonIcon, IonLabel } from '@ionic/react';
import { addCircle, cloudUploadOutline } from 'ionicons/icons';

interface ImageUploadButtonProps {
    isUploading: boolean;
    onUpload: () => void;
    disabled?: boolean;
    uploadingText?: string;
    style?: React.CSSProperties;
    slot?: string;
}

const ImageUploadButton: React.FC<ImageUploadButtonProps> = ({
    isUploading,
    onUpload,
    disabled = false,
    uploadingText = "Uploading...",
    style,
    slot = "end"
}) => {
    const handleClick = () => {
        if (!isUploading && !disabled) {
            onUpload();
        }
    };

    if (isUploading) {
        return (
            <>
                <IonLabel slot={slot} style={{ fontSize: '12px', color: '#3880ff', marginRight: '8px' }}>
                    {uploadingText}
                </IonLabel>
                <IonIcon 
                    icon={cloudUploadOutline} 
                    slot={slot}
                    style={{ 
                        color: '#3880ff',
                        animation: 'pulse 1.5s infinite',
                        ...style
                    }}
                />
            </>
        );
    }

    return (
        <IonIcon 
            icon={addCircle} 
            slot={slot}
            onClick={handleClick}
            style={{ 
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                ...style
            }}
        />
    );
};

export default ImageUploadButton;
